import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["picker", "list", "template", "standard"];

  add() {
    const option = this.pickerTarget.selectedOptions[0];
    if (!option?.value || this.listTarget.querySelector(`[data-part-code="${option.value}"]`)) return;

    const bands = Array.from(this.standardTarget.querySelectorAll(".markup-band")).map((row) => ({
      min_price: row.querySelector("[data-field=min]").value,
      percent: row.querySelector("[data-field=percent]").value
    }));
    const html = this.templateTarget.innerHTML
      .replaceAll("__CODE__", option.value)
      .replaceAll("__NAME__", option.textContent)
      .replace("__BANDS__", JSON.stringify(bands).replaceAll('"', "&quot;"));
    this.listTarget.insertAdjacentHTML("beforeend", html);
    option.disabled = true;
    this.pickerTarget.value = "";
  }

  remove(event) {
    const group = event.currentTarget.closest("[data-part-code]");
    const option = this.pickerTarget.querySelector(`option[value="${group.dataset.partCode}"]`);
    if (option) option.disabled = false;
    group.remove();
  }
}
